import form from "./form";


const {
    formField: {
        cardroomId,
        type
    },
} = form;

const initialValues = {
    [cardroomId.name]: "",
    [type.name]: 1
};

export default initialValues;
